var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('r-modal-container', {
    attrs: {
      "dialog": true,
      "icon": "warning",
      "iconColor": "fargo",
      "iconSize": "56",
      "title": _vm.title,
      "headerPaddingBottom": 16
    },
    scopedSlots: _vm._u([{
      key: "controls",
      fn: function () {
        return [_c('r-row', {
          attrs: {
            "gap-hidden": ""
          }
        }, [_c('r-col', {
          attrs: {
            "cols": {
              widest: 6,
              wide: 6,
              middle: 6,
              narrow: 6
            }
          }
        }, [_c('r-button', {
          attrs: {
            "title": "Нет, отменить",
            "type": "secondary",
            "width": "wide"
          },
          on: {
            "click": function ($event) {
              return _vm.onClose();
            }
          }
        })], 1), _c('r-col', {
          attrs: {
            "cols": {
              widest: 6,
              wide: 6,
              middle: 6,
              narrow: 6
            }
          }
        }, [_c('r-button', {
          attrs: {
            "title": "Да, пометить",
            "width": "wide"
          },
          on: {
            "click": function ($event) {
              return _vm.onConfirm();
            }
          }
        })], 1)], 1)];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "feta metropolis--text mb-6"
  }, [_vm._v(" " + _vm._s(_vm.all ? _vm.count : _vm.messageSingle) + " ")]), _vm.all ? [_c('div', {
    staticClass: "parmigiano troy--text mb-3"
  }, [_vm._v(" Среди отмечаемых как прочтённые оповещений есть особо важные. ")]), _c('div', {
    staticClass: "parmigiano troy--text"
  }, [_vm._v(" Вы точно хотите отметить все, как прочитанные? ")])] : _vm._e(), !_vm.all ? [_c('div', {
    staticClass: "parmigiano troy--text mb-3"
  }, [_vm._v(" Оповещение " + _vm._s(_vm.text) + " модуля " + _vm._s(_vm.moduleName) + " является особо важным. ")]), _c('div', {
    staticClass: "parmigiano troy--text"
  }, [_vm._v(" Вы точно хотите пометить его, как прочитанное? ")])] : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }